/**
 *
 * ModalSendTestSurvey
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Modal, Input, Button } from "antd"
import { map, filter, split, concat } from "lodash"
import validateEmail from "../../utils/validateEmail"
import "./index.less"
import { CloseOutlined } from "@ant-design/icons"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_btns, buttonAction_s } from "../Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */

let buttonAction_btn = (tipo) => {
  let data_button_prev = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: tipo,
    label: `Click a ${tipo}`,
    property: "button",
    value: LOCAL_USER_ID(),
  }
  buttonAction_s(data_button_prev)
}
class ModalSendTestSurvey extends React.Component {
  state = {
    testEmailsArr: [],
    inputEmail: "",
  }

  handleEnterPress = (e) => {
    if (e.key === "Enter") {
      const { testEmailsArr, inputEmail } = this.state

      this.setState({
        testEmailsArr: concat(
          testEmailsArr,
          filter(
            split(inputEmail, ","),
            (item) => item.trim() && !testEmailsArr.includes(item.trim())
          )
        ),
        inputEmail: "",
      })
    }
  }

  handleDeleteEmailClick = (itemDelete) => {
    this.setState({
      testEmailsArr: filter(
        this.state.testEmailsArr,
        (item) => item !== itemDelete
      ),
    })
  }

  handleCloseClick = () => {
    this.props.setStateFrom("modalSendTestSurvey", false)
    this.setState({ testEmailsArr: [], inputEmail: "" })
  }

  validateEmails = () => {
    return filter(
      this.state.testEmailsArr,
      (item) => !validateEmail(item.trim())
    ).length
  }

  render() {
    return (
      <Modal
        title="Enviar encuesta de prueba"
        className="modal-send-test-survey"
        style={{ top: 76 }}
        closable
        visible={this.props.modalSendTestSurvey}
        onCancel={() => this.handleCloseClick()}
        footer={[
          <Button
            key="back"
            onClick={() => {
              this.handleCloseClick()
              buttonAction_btns("Cancelar envio encuesta de prueba")
            }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            // disabled={this.state.inputEmail ? !validateEmail(this.state.inputEmail) : (!this.state.testEmailsArr.length || this.validateEmails())}
            disabled={
              this.state.inputEmail.length && !this.state.testEmailsArr.length
                ? !validateEmail(this.state.inputEmail)
                : !this.state.testEmailsArr.length || this.validateEmails()
            }
            onClick={() => {
              const { match } = this.props

              const params = {
                idMeasurement: match.params.id,
                params: {
                  emails:
                    this.state.inputEmail.length &&
                    !this.state.testEmailsArr.length
                      ? [this.state.inputEmail]
                      : this.state.testEmailsArr,
                },
              }

              this.props.stepThirdWatcher(params)
              this.handleCloseClick()
              buttonAction_btns("Enviar encuesta de prueba")
            }}>
            Enviar
          </Button>,
        ]}
        width={520}>
        <p className="send-proof-modal">
          Ingresa los <span>correos electrónicos</span> a los que deseas enviar
          la encuesta de prueba:
        </p>
        {!!this.validateEmails() && (
          <p
            style={{
              color: "#EA6364",
              width: 290,
              textAlign: "right",
              marginBottom: 4,
            }}>
            El correo electrónico no es valido
          </p>
        )}
        <Input
          value={this.state.inputEmail}
          style={{ width: 290, marginBottom: 8 }}
          onKeyPress={this.handleEnterPress}
          placeholder="hola@hola.com, prueba@prueba.com"
          onChange={(e) => this.setState({ inputEmail: e.target.value })}
        />
        <p style={{ fontSize: 12, color: "#766D6D" }}>
          Utiliza una coma como separación y luego presiona Enter si deseas
          introducir más de un correo.
        </p>
        <ul className="send-proof-modal-list">
          {map(this.state.testEmailsArr, (item, index) => {
            return (
              <li
                key={index}
                style={{
                  borderColor: validateEmail(item.trim()) ? "" : "#EA6364",
                  borderWidth: 1,
                }}>
                {item}{" "}
                <CloseOutlined
                  onClick={() => this.handleDeleteEmailClick(item)}
                />
              </li>
            )
          })}
        </ul>
      </Modal>
    )
  }
}

ModalSendTestSurvey.propTypes = {}

export default ModalSendTestSurvey
